import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import './theme.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ThemeProvider } from './ThemeContext';
import ThemeToggle from './components/ThemeToggle';

import Dashboard from './components/Admin/admin-components/Dashboard';
import Login from './components/Admin/Login';
import Vendor from './components/Admin/admin-components/vendor';
import Customer from './components/Admin/admin-components/customer';
import Notification from './components/Admin/admin-components/notification';
import PendingApprovals from './components/Admin/admin-components/PendingApprovals';
import Orders from './components/Admin/admin-components/Orders';
import VendorDetails from './components/Admin/admin-components/VendorDetails';
import CustomerManagement from './components/Admin/admin-components/CustomerManagement';
import CategoryManagement from './components/Admin/admin-components/CategoryManagement';
import ProtectedRoute from './components/Admin/admin-components/ProtectedRoute';

function App() {
  return (
    <ThemeProvider>
      <Router>
        <div className="App">
          <Routes>
            {/* Public Routes */}
            <Route path="/admin_login" element={<Login />} />

            {/* Protected Routes */}
            <Route path="/" element={
              <ProtectedRoute>
                <Dashboard />
              </ProtectedRoute>
            } />

            <Route path="/vendor" element={
              <ProtectedRoute>
                <Vendor />
              </ProtectedRoute>
            } />

            <Route path="/vendors" element={
              <ProtectedRoute>
                <Customer />
              </ProtectedRoute>
            } />

            <Route path="/vendor/:id" element={
              <ProtectedRoute>
                <VendorDetails />
              </ProtectedRoute>
            } />

            {/* Legacy customer route redirects to vendors */}
            <Route path="/customer" element={
              <ProtectedRoute>
                <Customer />
              </ProtectedRoute>
            } />

            <Route path="/customers" element={
              <ProtectedRoute>
                <CustomerManagement />
              </ProtectedRoute>
            } />

            <Route path="/pending" element={
              <ProtectedRoute>
                <PendingApprovals />
              </ProtectedRoute>
            } />

            <Route path="/orders" element={
              <ProtectedRoute>
                <Orders />
              </ProtectedRoute>
            } />

            <Route path="/categories" element={
              <ProtectedRoute>
                <CategoryManagement />
              </ProtectedRoute>
            } />

            <Route path="/notification" element={
              <ProtectedRoute>
                <Notification />
              </ProtectedRoute>
            } />

            {/* Fallback - redirect to dashboard */}
            <Route path="*" element={
              <ProtectedRoute>
                <Dashboard />
              </ProtectedRoute>
            } />
          </Routes>

          {/* Theme Toggle Button */}
          <ThemeToggle />
        </div>
      </Router>
    </ThemeProvider>
  );
}

export default App;
